export default __webpack_public_path__ + "static/media/kitchen3-after1-2048w.b2af6624.avif";